if (!window.__mikRevealObserver) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  document.querySelectorAll('[data-mik-reveal]').forEach((el) => {
    el.classList.add('mik-reveal-init');
    observer.observe(el);
  });

  window.__mikRevealObserver = observer;
}
